import { Menu, MenuItem } from '@mui/material';

import { HeaderMenuProps } from './types';

export const HeaderMenu = ({
  anchorEl,
  handleClose,
  options,
  title,
}: HeaderMenuProps) => {
  return (
    <Menu
      id={`menu-${title}`}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      {options.map(({ onClick, label }) => (
        <MenuItem key={`menu-${title}-item-${label}`} onClick={() => onClick()}>
          {label}
        </MenuItem>
      ))}
    </Menu>
  );
};
